import { performRequest } from './utils/RequestUtils';
import { LIBRARY_ENDPOINT } from './utils/EndPoint';
import axios from 'axios';

export const getMybookList = async (user_id) => {
    return performRequest('get', `${LIBRARY_ENDPOINT}/${user_id}`);
};

export const getStoryLandList = async () => {
    return performRequest('get', `${LIBRARY_ENDPOINT}/storyland`);
};

export const getStoryLandBookInfo = async (book_id) => {
    return performRequest('get', `${LIBRARY_ENDPOINT}/storyland/${book_id}`);
};

export const logStorylandReading = async (user_id, book_id) => {
    return performRequest(
        'get',
        `${LIBRARY_ENDPOINT}/storyland/reading/${user_id}/${book_id}`
    );
};

export const getStoryLandforLoading = async () => {
    return performRequest('get', `${LIBRARY_ENDPOINT}/storyland/loading`);
};

// 사용자 책 읽기
export const getBookContents = async (book_id) => {
    return performRequest('get', `${LIBRARY_ENDPOINT}/contents/${book_id}`);
};

export const generateTTS = async (user_id, text, speaker, speed) => {
    return performRequest(
        'post',
        `${LIBRARY_ENDPOINT}/tts`,
        { user_id, text, speaker, speed },
        'blob'
    ); // 📌 TTS 요청은 'blob' 지정
};

// ---------- 경남 관련 ----------
export const getStoryLandListByGyeongnam = async () => {
    return performRequest(
        'get',
        `${LIBRARY_ENDPOINT}/storyland/list/gyeongnam`
    );
};

// ---------- 오디오북 관련 API ----------
// 녹음 오디오북 임시 저장
export const saveTempRecordingFiles = async (user_id, book_id, files) => {
    const formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('book_id', book_id);
    files.forEach((file) => formData.append('files', file));

    return performRequest(
        'post',
        `${LIBRARY_ENDPOINT}/audiobook/recording/create`,
        formData
    );
};

// 녹음 오디오북 정식 생성
export const createAudioBook = async (user_id, temp_id, title) => {
    return performRequest(
        'post',
        `${LIBRARY_ENDPOINT}/audiobook/create/recording`,
        { user_id, temp_id, title }
    );
};

// 생성된 오디오북 리스트 조회
export const getAudioBookList = async (book_id) => {
    return performRequest(
        'get',
        `${LIBRARY_ENDPOINT}/audiobook/list/${book_id}`
    );
};

// 책 내용 상세 조회(오디오북)
export const getAudioBookDetail = async (audiobook_id) => {
    return performRequest(
        'get',
        `${LIBRARY_ENDPOINT}/audiobook/${audiobook_id}`
    );
};

// AI 오디오북 생성
export const createAIAudioBook = async (user_id, book_id, voice_type) => {
    try {
        const res = await axios.post(
            `${LIBRARY_ENDPOINT}/audiobook/create/ai`,
            {
                user_id,
                book_id,
                voice_type,
            }
        );
        return res.data;
    } catch (err) {
        console.error('AI오디오북 생성 오류', err);
        if (err.response?.data) return err.response.data;

        return {
            success: false,
            errorCode: 'NETWORK_ERROR',
            errorMessage: err.message || '네트워크 오류 발생',
        };
    }
};

// 오디오북 삭제
export const deleteAudioBooks = async (audiobook_ids) => {
    try {
        const res = await fetch(`${LIBRARY_ENDPOINT}/audiobook`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ audiobook_ids: audiobook_ids }),
        });
        return await res.json();
    } catch (err) {
        console.error('AI오디오북 삭제 중 오류 발생', err);
        return {
            success: false,
            errorMessage: '네트워크 오류',
        };
    }
};

// 내 목소리 기반 AI 오디오북 생성
export const createCustomVoiceAudiobook = async ({
    voiceFile,
    user_id,
    book_id,
}) => {
    try {
        const form = new FormData();
        form.append(
            'voiceFile',
            voiceFile,
            voiceFile.name || 'voice-sample.webm'
        );
        form.append('user_id', String(user_id));
        form.append('book_id', String(book_id));

        const res = await axios.post(
            `${LIBRARY_ENDPOINT}/audiobook/custom/create`,
            form
        );
        return res.data;
    } catch (err) {
        console.error('createCustomVoiceAudiobook error RAW --->', err);

        if (err.response) {
            console.log(
                '❗ 서버 응답 status:',
                err.response.status,
                'data:',
                err.response.data
            );
        }

        if (err.response?.data) return err.response.data;

        return {
            success: false,
            errorCode: 'NETWORK_ERROR',
            errorMessage: err?.message || '네트워크 오류',
        };
    }
};

// 오디오북 제목 확정(커스텀.녹음)
export const confirmAuidoBookTitle = async (audiobook_id, title) => {
    return performRequest(
        'post',
        `${LIBRARY_ENDPOINT}/audiobook/custom/title`,
        { audiobook_id, title }
    );
};
